import { Models } from "@hex-insights/app-modules";
import { daysOfWeek } from "@hex-insights/core";
import { CourseSectionPeriod } from "../../../Utilities";
import * as ModelFormat from "../_General";

// Note: the functions defined in this file can be passed to model field components for consistent formatting.

/**
 * Formats the dayOfWeek field of the CourseSectionPeriod model.
 */
export function dayOfWeek(value: CourseSectionPeriod["dayOfWeek"] | null): string {
	if (!value) {
		return Models.toString(value);
	}

	return daysOfWeek[value] || "Unknown";
}

/**
 * Formats the startTimeMinutes field of the CourseSectionPeriod model.
 */
export function startTimeMinutes(value: CourseSectionPeriod["startTimeMinutes"] | null): string {
	return ModelFormat.minutes(value);
}

/**
 * Formats the endTimeMinutes field of the CourseSectionPeriod model.
 */
export function endTimeMinutes(value: CourseSectionPeriod["endTimeMinutes"] | null): string {
	return ModelFormat.minutes(value);
}

/**
 * Formats the isActive field of the CourseSectionPeriod model.
 */
export function isActive(value: CourseSectionPeriod["isActive"]): string {
	return Models.toString(value);
}
